@if (createNewMode) {
  @if (netzbetreiber$ | async; as netzbetreiber) {
    <redispatch-erzeugungsanlage-detail-form
      [netzbetreiber]="netzbetreiber"
      [createNewMode]="true"
      [readonly]="false">
    </redispatch-erzeugungsanlage-detail-form>
  }
} @else {
  @if (erzeugungsanlage$ | async; as erzeugungsanlage) {
    <redispatch-erzeugungsanlage-detail-form
      [netzbetreiber]="erzeugungsanlage.netzzuordnung.netzbetreiber"
      [createNewMode]="false"
      [erzeugungsanlage]="erzeugungsanlage"
      [readonly]="readonly$ | async">
    </redispatch-erzeugungsanlage-detail-form>
  }
}
